import {
    apiRequest,
    bobotTunjanganKhususCreate, 
    bobotTunjanganKhususUpdate,
} from "../../../../../../services/adapters/master/bobotTunjanganKhususService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", bobotTunjanganKhususCreate, {
            body: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", bobotTunjanganKhususUpdate, {
            body: query
        }, true)
    }
}

export default CreateRepository